import { STRING_getInstance2dgfp43qdvxn4 as STRING_getInstance } from '../descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptorkwnwsc78b2on as PrimitiveSerialDescriptor } from './Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstance229rema5imh9m as Companion_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NothingSerialDescriptor_getInstance2rrygbd8egptl as NothingSerialDescriptor_getInstance } from './NothingSerialDescriptor.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import {
  Duration__toIsoString_impl_9h6wsm39deca2yd73rf as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance1ji65oeucwbu1 as Companion_getInstance_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance20qyxpgw1gyvv as Companion_getInstance_1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var InstantSerializerClass;
function InstantSerializer() {
  if (InstantSerializerClass === VOID) {
    class $ {
      constructor() {
        InstantSerializer_instance = this;
        this.p1t_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Instant', STRING_getInstance());
      }
      x1m() {
        return this.p1t_1;
      }
      q1t(encoder, value) {
        encoder.t1s(value.toString());
      }
      y1m(encoder, value) {
        return this.q1t(encoder, value instanceof Instant() ? value : THROW_CCE());
      }
      z1m(decoder) {
        return Companion_getInstance().ur(decoder.j1r());
      }
    }
    initMetadataForObject($, 'InstantSerializer', VOID, VOID, [KSerializer()]);
    InstantSerializerClass = $;
  }
  return InstantSerializerClass;
}
var InstantSerializer_instance;
function InstantSerializer_getInstance() {
  if (InstantSerializer_instance === VOID)
    new (InstantSerializer())();
  return InstantSerializer_instance;
}
var NothingSerializerClass;
function NothingSerializer() {
  if (NothingSerializerClass === VOID) {
    class $ {
      constructor() {
        NothingSerializer_instance = this;
        this.r1t_1 = NothingSerialDescriptor_getInstance();
      }
      x1m() {
        return this.r1t_1;
      }
      s1t(encoder, value) {
        throw SerializationException().s1o("'kotlin.Nothing' cannot be serialized");
      }
      y1m(encoder, value) {
        var tmp;
        if (false) {
          tmp = value;
        } else {
          tmp = THROW_CCE();
        }
        return this.s1t(encoder, tmp);
      }
      z1m(decoder) {
        throw SerializationException().s1o("'kotlin.Nothing' does not have instances");
      }
    }
    initMetadataForObject($, 'NothingSerializer', VOID, VOID, [KSerializer()]);
    NothingSerializerClass = $;
  }
  return NothingSerializerClass;
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new (NothingSerializer())();
  return NothingSerializer_instance;
}
var DurationSerializerClass;
function DurationSerializer() {
  if (DurationSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationSerializer_instance = this;
        this.t1t_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Duration', STRING_getInstance());
      }
      x1m() {
        return this.t1t_1;
      }
      u1t(encoder, value) {
        encoder.t1s(Duration__toIsoString_impl_9h6wsm(value));
      }
      y1m(encoder, value) {
        return this.u1t(encoder, value instanceof Duration() ? value.hi_1 : THROW_CCE());
      }
      v1t(decoder) {
        return Companion_getInstance_0().jr(decoder.j1r());
      }
      z1m(decoder) {
        return new (Duration())(this.v1t(decoder));
      }
    }
    initMetadataForObject($, 'DurationSerializer', VOID, VOID, [KSerializer()]);
    DurationSerializerClass = $;
  }
  return DurationSerializerClass;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new (DurationSerializer())();
  return DurationSerializer_instance;
}
var UuidSerializerClass;
function UuidSerializer() {
  if (UuidSerializerClass === VOID) {
    class $ {
      constructor() {
        UuidSerializer_instance = this;
        this.w1t_1 = new (PrimitiveSerialDescriptor())('kotlin.uuid.Uuid', STRING_getInstance());
      }
      x1m() {
        return this.w1t_1;
      }
      x1t(encoder, value) {
        encoder.t1s(value.toString());
      }
      y1m(encoder, value) {
        return this.x1t(encoder, value instanceof Uuid() ? value : THROW_CCE());
      }
      z1m(decoder) {
        return Companion_getInstance_1().ot(decoder.j1r());
      }
    }
    initMetadataForObject($, 'UuidSerializer', VOID, VOID, [KSerializer()]);
    UuidSerializerClass = $;
  }
  return UuidSerializerClass;
}
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance === VOID)
    new (UuidSerializer())();
  return UuidSerializer_instance;
}
//region block: exports
export {
  DurationSerializer_getInstance as DurationSerializer_getInstanceuy18n30pdnsl,
  InstantSerializer_getInstance as InstantSerializer_getInstance22qmsuun6eooc,
  NothingSerializer_getInstance as NothingSerializer_getInstancet9nva061awti,
  UuidSerializer_getInstance as UuidSerializer_getInstance3aa17pw3rg0t5,
};
//endregion

//# sourceMappingURL=BuiltInSerializers.mjs.map
